/* eslint-disable prettier/prettier */
import { types, flow, cast } from 'mobx-state-tree';
import { format } from 'date-fns';

import * as API from '@src/services/companies';
import { ApiStore } from '@src/features/common';
import { toast } from 'src/components';

const File = types.model('AddCandidateModal', {
    name: types.string,
    url: types.string,
    date: types.string,
    fileType: types.string,
    dateRaw: types.frozen(),
    id: types.number
})

export const DocumentsStore = types
    .compose(
        ApiStore,
        types.model({
            docs: types.array(File),
        })
    )
    .actions(self => {
        const fetchDocs = flow(function* fetch() {
            const res = yield self.fetch(API.docsURL())

            self.docs = res.map(item => ({
                name: item.name || item.document_filename,
                url: item.document_url,
                date: format(new Date(item.visible_date || item.created_at), 'd LLL R'),
                dateRaw: new Date(item.created_at),
                fileType: item.document_filename.split('.').pop(),
                id: item.id
            }))
        })

        return {
            fetchDocs,
            deleteDoc: flow(function* fetch(id) {
                yield self.delete(API.docsURL(id), {}, {
                    onFetchSuccess: message => {
                        toast.info(message.notice || message?.messages?.join?.(' '));

                        self.docs = cast(self.docs.filter(item => item.id !== id))
                    }
                })

            })
        };
    });
